<ng-container [formGroup]="formData">
  <div class="mu-currency-icon"><ng-content select="[mu-icon]"></ng-content></div>
  <input
    pInputText
    [id]="controlName"
    [name]="controlName"
    [formControlName]="controlName"
    [placeholder]="hidePlaceholder ? '' : ('form.placeholder.' + controlName | translate)"
    (keydown)="cleanCurrency()"
    (blur)="checkField()"
    (keydown.enter)="onEnterAction()"
    [style.width.ch]="width"
  />
  <ng-container *ngIf="hideLabel">
    <div class="mu-form-label" [ngClass]="{ show: showEdit }">
      <span (click)="onActionClick()">{{ 'form.label.labelRecharge' | translate }}</span>
    </div>
  </ng-container>
</ng-container>
